import Api from "./base/api-base";

export default class WorkerDailyReportExpenseBulkApi {

  list(start_date, end_date, construction_id, department_id, management_user_id, worker_user_id) {
    return Api.link.get({
      links: [
        {endpoint: Api.endpoint.worker_daily_report_expense_bulk},
        {endpoint: "/start", id: start_date},
        {endpoint: "/end", id: end_date},
        {endpoint: "/construction", id: construction_id},
        {endpoint: "/department", id: department_id},
        {endpoint: "/management", id: management_user_id},
        {endpoint: "/worker", id: worker_user_id},
      ]
    });
  }

  info (id) {
    return Api.get({
      endpoint: Api.endpoint.worker_daily_report_expense_bulk,
      id: id
    });
  }

  update (id, params) {
    return Api.post({
      endpoint: Api.endpoint.worker_daily_report_expense_bulk,
      id: id,
      params: params
    });
  }
}
